<template>
  <div>

  <section class="hero is-white skew">
  <div class="hero-body" style="padding-top:0;">
    <div class="container">
            <div class="columns is-multiline">
  <div class="column is-10 is-offset-1 has-text-centered">
    <h2 class="is-size-2 is-size-3-mobile script">{{ view.content.headline }}</h2>
  </div> 
  <div class="column is-10 is-offset-1 has-text-centered">
    {{ view.content.subtitle }}
  </div>
</div>
    </div>
  </div>
</section>


    <section v-if="view.content.team.length" 
    v-for="(i, index) in view.content.team" 
    :class="{ 
      'hero': true, 
      'skew': true, 
      'is-secondary' : !(index % 2),
      'is-white' : index % 2
    }"
    :key="index">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-3 has-text-centered" v-if="i.image.length">
                <figure>
                <div class="img-circle" :style="'background-image: url(' + assetsBaseUrl + i.image + ');'">
                </div>
                <p v-if="i.download.length"><a class="button is-rounded is-primary" :href="assetsBaseUrl + i.download" target="_blank">Lebenslauf</a></p>
              </figure>
            </div> 
            <div class="column">
              <div class="column is-12"><a class="icon is-pulled-right" v-for="(social, key, item) in i.social" v-if="social.length" :href="key === 'envelope' ? ('mailto:' + social) : social" :target="key != 'envelope' ? '_blank' : ''"><i :class="'fa fa-' + key"></i></a></div>

              <div class="column is-12">
              <h2 class="is-size-5 is-size-6-mobile has-text-weight-bold is-capitalized" v-html="i.name"></h2>
              <h3 class="is-size-5 is-size-6-mobile">{{ i.title }}</h3>
              <p class="is-size-6 is-size-7-mobile" style="margin-top:20px;white-space: pre-line;" v-html="i.text"></p>
              <p v-if="!i.image.length && i.download.length" style="margin-top:20px;"><a class="button is-rounded is-primary" :href="assetsBaseUrl + i.download" target="_blank">Lebenslauf</a></p>
            </div>
            </div> 
          </div>
        </div>
      </div>
    </section>


    <section v-if="view.content.text.length" class="hero is-white skew">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <span class="content" v-html="view.content.text"></span>

            </div> 
          </div>
        </div>
      </div>
    </section>



  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: ['view'],
  computed: {
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    }
  },
  components: {
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/Team.vue